import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

import { DenseInput, FieldLabel, LockIcon, STAFF_FONT, tone } from "./setup/ui";

/** A field locked after the first entry: lock icon, read-only value and the
 * server's reason and alternative (F11). */
export function LockedField({
  id,
  label,
  value,
  reason,
  alternative,
  openTip,
}: {
  id: string;
  label: string;
  value: string;
  reason: string;
  alternative?: string | null;
  openTip?: boolean;
}) {
  const text = alternative ? `${reason} ${alternative}` : reason;
  return (
    <Box>
      <FieldLabel htmlFor={id}>
        {label}
        <Tooltip
          open={openTip || undefined}
          placement="bottom-start"
          slotProps={{
            tooltip: {
              sx: { bgcolor: tone.ink, color: tone.onInk, borderRadius: "8px", p: "10px 12px", fontFamily: STAFF_FONT, fontSize: 12.5, lineHeight: 1.45, maxWidth: 290 },
            },
          }}
          title={text}
        >
          <Box
            aria-label="Why is this locked?"
            component="button"
            sx={{ border: 0, bgcolor: "transparent", p: 0, color: tone.subtle, display: "inline-flex", cursor: "pointer" }}
            type="button"
          >
            <LockIcon size={13} />
          </Box>
        </Tooltip>
      </FieldLabel>
      <DenseInput aria-describedby={`${id}-reason`} id={id} mono readOnly sx={{ bgcolor: tone.page, color: tone.muted }} value={value} />
      <Box id={`${id}-reason`} sx={{ position: "absolute", left: -9999 }}>
        {text}
      </Box>
    </Box>
  );
}
